<template>
  <div>
    <base-header type="gradient-primary" class="pb-10 pb-8 pt-5 pt-md-8">
      <!-- Card stats -->
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div class="card shadow">
            <datatable-header title="Resources">
              <modal-icon-button
                slot="header-right"
                v-if="$store.getters.hasRoles(['createResource'])"
                modalTarget="#createResource"
                icon="fa fa-plus"
              />
            </datatable-header>
            <resources-table :resources="resources" />
            <datatable-footer
              @onNextPage="nextPage"
              @onPrevPage="prevPage"
              :showPrevPageBtn="showPrevPageBtn"
              :showNextPageBtn="showNextPageBtn"
            />
          </div>
        </div>
      </div>
    </div>

    <modal id="createResource" title="Create Resource">
      <create-resource-form />
    </modal>
  </div>
</template>

<script>
import firebase from "@/config/firebase.js";

import DataTableHeader from "@/components/DataTable/DataTableHeader.vue";
import ResourcesTable from "@/views/resources/components/ResourcesTable.vue";
import DataTableFooter from "@/components/DataTable/DataTableFooter.vue";

import ModalIconButton from "@/components/Buttons/ModalIconButton.vue";

import CreateResourceForm from "@/views/resources/components/CreateResourceForm.vue";
import Modal from "@/components/Modal.vue";

export default {
  components: {
    "datatable-header": DataTableHeader,
    "resources-table": ResourcesTable,
    "datatable-footer": DataTableFooter,
    "modal-icon-button": ModalIconButton,
    "create-resource-form": CreateResourceForm,
    modal: Modal
  },
  data() {
    return {
      resources: [],
      prevResourcesRef: null,
      nextResourcesRef: null,
      loading: false,
      showPrevPageBtn: true,
      showNextPageBtn: true,
      currentResourcesRef: null
    };
  },
  computed: {
    curOrg() {
      return this.$store.state.usermain.curOrg;
    },
  },
  watch: {
    curOrg(newCurOrg, _) {
      this.getResources(newCurOrg);
    }
  },
  mounted() {
    this.getResources(this.curOrg);
  },
  methods: {
    nextPage() {
      if (!this.loading) {
        this.loading = true;

        this.prevResourcesRef = this.currentResourcesRef;

        this.currentResourcesRef = this.nextResourcesRef;
        this.currentResourcesRef
          .get()
          .then(q => this.handleNewResourcesData(q, "next"));
      }
    },
    prevPage() {
      if (!this.loading) {
        this.loading = true;

        this.nextResourcesRef = this.currentResourcesRef;
        this.currentResourcesRef = this.prevResourcesRef;

        this.currentResourcesRef
          .get()
          .then(q => this.handleNewResourcesData(q, "prev"));
      }
    },
    baseRef(orgData) {
      var resourcesCollection;

      resourcesCollection = firebase
        .firestore()
        .collection("organizations/" + orgData.id + "/resources");

      return resourcesCollection.orderBy("createDate", "desc");
    },
    getResources(orgData) {
      if (orgData.id != null) {
        console.log(orgData);

        this.loading = true;

        this.currentResourcesRef = this.baseRef(orgData).limit(10);

        this.currentResourcesRef.get().then(this.handleNewResourcesData);
      }
    },
    handleNewResourcesData(querySnapshot, buttonClicked = "initial") {
      const documents = querySnapshot.docs.map(doc => {
        const docData = doc.data();
        docData.id = doc.id;

        return docData;
      });

      this.resources = documents;

      const firstDocument = querySnapshot.docs[0];
      const lastDocument = querySnapshot.docs[querySnapshot.docs.length - 1];

      if (firstDocument) {
        this.prevResourcesRef = this.baseRef(this.curOrg)
          .endBefore(firstDocument)
          .limitToLast(10);
      }

      if (lastDocument) {
        this.nextResourcesRef = this.baseRef(this.curOrg)
          .startAfter(lastDocument)
          .limit(10);
      }

      if (documents.length <= 0) {
        if (buttonClicked === "next") {
          this.showPrevPageBtn = true;
          this.showNextPageBtn = false;
        }
        if (buttonClicked === "prev") {
          this.showPrevPageBtn = false;
          this.showNextPageBtn = true;
        }
      } else {
        this.showPrevPageBtn = true;
        this.showNextPageBtn = true;
      }

      this.loading = false;
    }
  }
};
</script>
<style></style>
